export const addSchedule = '/dashboard/tasks';
export const schedules = '/dashboard/getTasks';
export const updateScheduleStatus = '/dashboard/updateStatus/';
